export default __webpack_public_path__ + "f48f959.png";